"use strict";

function deferred() {
  var result = {};
  result.promise = new Promise(function (resolve, reject) {
    result.resolve = resolve;
    result.reject = reject;
  });
  return result;
}

module.exports = deferred;


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty/dist/node/lib/utils/deferred.js
 ** module id = 458
 ** module chunks = 0
 **/